import React from "react";
import CorporateAccess from "../CorporateAccess";

export default function RecoverPassword() { return <CorporateAccess initialMode="otp" />; }
